import store from "@/config/vuex/store";

export default [
    {
        path: "/motoristas",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "motoristasRead",
                component: () => import('@/pages/Motorista/MotoristaRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "cadastrar",
                name: "motoristasCreate",
                component: () => import('@/pages/Motorista/MotoristaCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "motoristasUpdate",
                component: () => import('@/pages/Motorista/MotoristaUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "carros",
                name: "motoristasCarroRead",
                component: () => import('@/pages/Motorista/MotoristaCarroRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "postos",
                name: "motoristasPostoRead",
                component: () => import('@/pages/Motorista/PostoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "posto-visualizar",
                name: "motoristasPostoView",
                component: () => import('@/pages/Motorista/PostoView'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "gastos",
                name: "motoristasGastoRead",
                component: () => import('@/pages/Motorista/MotoristaGastoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

